import { render } from "./TableOfContentsItem.vue?vue&type=template&id=ca45273e&scoped=true"
import script from "./TableOfContentsItem.vue?vue&type=script&lang=js"
export * from "./TableOfContentsItem.vue?vue&type=script&lang=js"

import "./TableOfContentsItem.vue?vue&type=style&index=0&id=ca45273e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca45273e"]])

export default __exports__